import { createAction, props } from '@ngrx/store';
import { ButtonSelectionActionTypes } from './action-types';

export const DISABLE_TASK_BAR_BUTTON_NAVIGATION = createAction(
  ButtonSelectionActionTypes.DisableTaskBarButtonNavigation,
  props<{ isNavigationDisabled: boolean }>()
);

export const STATUS_BAR_MODULE_SELECTED = createAction(
  ButtonSelectionActionTypes.StatusBarModuleSelected,
  props<{ button: string }>()
);
